import { stackOffsetExpand, stackOffsetDiverging, stackOffsetNone, stackOffsetSilhouette, stackOffsetWiggle } from 'd3-shape';
export var STACK_OFFSETS = {
  expand: stackOffsetExpand,
  diverging: stackOffsetDiverging,
  none: stackOffsetNone,
  silhouette: stackOffsetSilhouette,
  wiggle: stackOffsetWiggle
};
export var STACK_OFFSET_NAMES = Object.keys(STACK_OFFSETS);
export default function stackOffset(offset) {
  return offset && STACK_OFFSETS[offset] || STACK_OFFSETS.none;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vx/shape/esm/util/stackOffset.js
// module id = 134
// module chunks = 0